module.exports = "/_next/static/images/mobile-hero-shapes-15700d08a130c991defea93f7e6a75f5.png";